module.exports = __webpack_public_path__ + "static/media/img4.5662fa54.jpeg";